<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
<!--    {{user.department}}-->
    <div v-if="loading ">
      <loading-autocomplete
          v-if="this.edit === false"
          placeholder="Введите ФИО и выберете из предложенных вариантов"
          label="Работник"
          outlined
          class="mt-4 mb-n2"
          v-model="user.user"
          search-parameter="fio"
          :load-fios="false"
          :url="user_selector"
          :error="hasError('user')"
          :errorMessages="getError('user')"
      >
        <template v-slot:no-data>
          <div>
            Для поиска начните набирать ФИО, <br> и либо остановитесь на 1 секунду, либо нажмите Enter
          </div>
        </template>
      </loading-autocomplete>
      <v-checkbox
          v-model="user.is_admin"
          label="Администратор"
          :error="hasError('is_admin')"
          :error-messages="getError('is_admin')"
      ></v-checkbox>
      <v-checkbox
          v-model="user.is_observer"
          :error="hasError('is_observer')"
          :error-messages="getError('is_observer')"
          label="Наблюдатель"
      ></v-checkbox>
      <v-checkbox
          v-model="user.is_entitled"
          :error="hasError('is_entitled')"
          :error-messages="getError('is_entitled')"
          label="Согласующий"
      ></v-checkbox>
      <v-autocomplete
          v-if="user.is_entitled"
          v-model="user.organization"
          :items="selectors.organizations"
          class="mt-4"
          label="Организация"
          outlined
          clearable
          :error="hasError('organization')"
          :errorMessages="getError('organization')"
      ></v-autocomplete>
      <v-autocomplete
          v-if="user.is_entitled"
          v-model="user.territory"
          :items="selectors.territories"
          label="Территория"
          outlined
          item-value="uid"
          item-text="name"
          clearable
          :error="hasError('territory')"
          :errorMessages="getError('territory')"
      ></v-autocomplete>
      <template v-if="user.is_entitled && user.territory">
        <template
            v-for="(item,index) in role_posts"
        >
          <v-autocomplete
              :key="index"
              v-model="item.id"
              :items="selectors.posts"
              label="Пост охраны"
              outlined
              :error="hasError('guard_posts')"
              :errorMessages="hasError('guard_posts') ? getError('guard_posts')[index] : null"
          >
            <template v-slot:prepend-item>
              <v-btn
                  block
                  elevation="0"
                  text
                  @click="newPost"
              >
                <v-icon>add</v-icon>
                Добавить пост охраны
              </v-btn>
              <v-divider class="primary"></v-divider>
            </template>
            <template v-slot:append-outer>
              <v-btn
                  v-if="role_posts.length !==1"
                  fab
                  icon
                  small
                  color="primary"
                  style="margin-top: -10px"
                  @click="deletePost(index)"
              >
                <v-icon>close</v-icon>
              </v-btn>
            </template>
          </v-autocomplete>
        </template>
      </template>
      <v-checkbox
          v-model="user.is_representative"
          :error="hasError('is_representative')"
          :error-messages="getError('is_representative')"
          label="Заявитель"
      ></v-checkbox>

      <v-alert
          v-if="user.is_representative"
          class="mt-4 rounded-lg"
          type="info"
          outlined
      >
        <p class="bold">Обратите внимание!</p>
        <p>Кол-во разовых пропусков в месяц, выданных на одного посетителя из числа пользователей MUCTR.</p>
      </v-alert>

      <v-row no-gutters v-if="user.is_representative" class="px-4">
        <v-col cols="12" class="mt-2">
          <v-text-field
              v-model="user.max_user_order"
              label="Кол-во разовых пропусков в месяц"
              type="number"
              outlined
              :error="hasError('max_user_order')"
              :errorMessages="getError('max_user_order')"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              v-model="user.max_auto_one_time"
              label="Кол-во разовых автомобильных пропусков в месяц"
              type="number"
              outlined
              :error="hasError('max_auto_one_time')"
              :errorMessages="getError('max_auto_one_time')"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field
              v-model="user.max_auto_constant"
              label="Кол-во временных автомобильных пропусков в месяц"
              type="number"
              outlined
              :error="hasError('max_auto_constant')"
              :errorMessages="getError('max_auto_constant')"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row no-gutters class="text-left mb-n2" v-if="edit && user.is_representative && !change_department">
<!--        <v-col cols="11" class="text&#45;&#45;secondary">-->
<!--          <span v-if="user.department" class="pl-2">{{user.department.name}}</span>-->
<!--          <span v-else>Подразделение отсутствует</span>-->
<!--        </v-col>-->
        <v-col cols="11" class="text--secondary" style="border: rgb(0, 0, 0, 50%) 1px solid; border-radius: 5px; padding: 16px 12px">
          <strong>Подразделение: </strong>
          <span v-if="user.department">{{user.department.name}}</span>
          <span v-else>Вы будете назначены ответственным по умолчанию</span>
        </v-col>
        <v-col cols="1" class="pl-sm-2 mt-5 mt-sm-2">
          <v-btn
              fab
              icon
              small
              color="primary"
              @click="changeDepartment"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    v-bind="attrs"
                    v-on="on"
                >
                  close
                </v-icon>
              </template>
              <span>Изменить подразделение</span>
            </v-tooltip>
          </v-btn>
        </v-col>
      </v-row>
      <loading-autocomplete
          v-if="user.is_representative && change_department"
          placeholder="Введите название подразделения и выберете из предложенных вариантов"
          label="Подразделение"
          v-model="user.department"
          search-parameter="department"
          :load-fios="false"
          outlined
          :url="department_selector"
          :error="hasError('department')"
          :errorMessages="getError('department')"
      >
        <template v-slot:no-data>
          <div>
            Для поиска начните набирать название подразделения, <br> и либо остановитесь на 1 секунду, либо нажмите Enter
          </div>
        </template>
      </loading-autocomplete>
      <v-alert v-if="hasError('detail') && !user.is_admin && !user.is_entitled && !user.is_representative
      && !user.is_observer" type="error">{{ getError('detail')[0]}}</v-alert>
    </div>
    <div class="action mt-8 mb-4 align-center" v-else>
      <semipolar-spinner
          class="d-inline-block"
          :animation-duration="2000"
          :size="115"
          color="#1935ff"
      />
    </div>
  </scroll-center-dialog>
</template>

<script>

import selectors from "@/urls/selectors";
import LoadingAutocomplete from "@/modules/core/components/LoadingAutocomplete";
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import {SemipolarSpinner} from "epic-spinners";

export default {
  name: "RolesEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    userData: Number
  },
  mixins:[FormErrorsMixin],
  components: {
    ScrollCenterDialog,
    LoadingAutocomplete,
    SemipolarSpinner
  },
  data() {
    return {
      loading:false,
      save_loading: false,
      first_loading: true,
      user_default: {
        user: "",
        is_admin: false,
        is_entitled: false,
        is_representative: false,
        is_observer: false,
        organization: null,
        territory: null,
        guard_posts: [],
        department: null,
        max_user_order: 10,
        max_auto_one_time: 3,
        max_auto_constant: 2
      },
      user: null,
      data_from_server: null,
      change_department: false,
      selectors: {
        departments: [],
        territories: [],
        organizations: [],
        posts:[]
      },
      role_posts: [
        {id: undefined}
      ]
    }
  },
  watch:{
    "user.is_admin"(){
      if(this.user.is_admin){
        if(!this.edit || !this.first_loading){
          this.user.is_entitled = true
          this.user.is_representative = true
          this.user.is_observer = true
        }
        else
          this.first_loading = false
      }
    },
    "user.territory"() {
      if(this.user.territory){
        this.loadPosts()
      } else if (this.user.territory == null) {
        this.role_posts = [
          {id: undefined}
        ]
        this.user.guard_posts = []
      }
    },
    "user.organization"() {
      if(this.user.organization){
        this.loadTerritories()
      } else if (this.user.organization == null) {
        this.user.territory = null
        this.role_posts = [
          {id: undefined}
        ]
        this.user.guard_posts = []
      }
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    form_title () {
      if(!this.edit)
        return "Добавить пользователя"
      else if (this.user)
        return this.user.name
    },
    user_selector(){
      return selectors.SELECTORS.USERS.ALL()
    },
    department_selector(){
      return selectors.SELECTORS.DEPARTMENTS.ALL()
    }
  },
  methods: {
    ...mapActions({
      createRoles: "admin/createRoles",
      changeRoles: "admin/changeRoles",
      loadRolesDetail: "admin/loadRolesDetail",
      loadTerritoriesSelector: "selectors/loadTerritoriesSelector",
      loadOrganizationSelector: "selectors/loadOrganizationSelector",
      loadPostsSelector: "selectors/loadPostsSelector"
    }),
    loadSelectors() {
      this.loadOrganizationSelector({
        url: undefined,
        finalizer: (val) => {
          this.selectors.organizations = val
        }
      })
    },
    loadPosts(url=undefined){
      this.loadPostsSelector({
        url: url,
        gets: { territory: this.user.territory },
        finalizer: (val) => {
          if (this.selectors.posts.length > 0 && this.selectors.posts !== val) {
            this.role_posts = [
              {id: undefined}
            ]
            this.user.guard_posts = []
          }
          this.selectors.posts = val
        }
      })
    },
    loadTerritories(url=undefined){
      this.loadTerritoriesSelector({
        url: undefined,
        gets: { organization: this.user.organization },
        finalizer: (val) => {
          this.selectors.territories = val
        }
      })
    },
    loadUserData(url=undefined){
      if(this.userData === undefined){
        this.user = this.user_default
        this.loading = true
      }
      else{
        this.loadRolesDetail({
          url: url,
          id: this.userData,
          finalizer: (data) => {
            this.user = data
            this.user.name = this.user.user.name
            this.user.user = this.user.user.uid
            // this.user.department = this.user.department ? this.user.department.uid : null
            this.user.organization = this.user.organization ? this.user.organization.uid : null
            this.user.territory = this.user.territory ? this.user.territory.uid : null
            this.role_posts = []
            if (data.guard_posts.length > 0) {
              for (let item in data.guard_posts) {
                delete data.guard_posts[item].name
                this.role_posts.push(data.guard_posts[item])
              }
              this.user.guard_posts = []
            } else {
              this.role_posts.push({id: undefined})
            }
            this.data_from_server = structuredClone(this.user);
            this.role_posts.forEach(el=>{
              if(el.id){
                this.data_from_server.guard_posts.push(el.id)
              }
            })
            this.loading = true
          }
        })
      }
    },
    newPost() {
      this.role_posts.push({id: undefined})
    },
    deletePost(index){
      if (this.role_posts.length > 1)
        this.role_posts.splice(index, 1)
    },
    changeDepartment(){
      this.user.department = null
      this.change_department = true
    },
    close(){
      this.$emit("close", false)
    },
    findDifferences(obj1, obj2) {
      const differences = {};

      function compareObjects(innerObj1, innerObj2, path) {
        for (let key in innerObj2) {
          if (innerObj2.hasOwnProperty(key)) {
            const newPath = path ? `${path}.${key}` : key;

            if (
                innerObj1.hasOwnProperty(key) &&
                typeof innerObj1[key] === 'object' &&
                typeof innerObj2[key] === 'object' &&
                !Array.isArray(innerObj1[key])
            ) {
              compareObjects(innerObj1[key], innerObj2[key], newPath);
            } else if (Array.isArray(innerObj1[key]) && Array.isArray(innerObj2[key])) {
              if (innerObj1[key].length !== innerObj2[key].length) {
                differences[newPath] = innerObj2[key];
              } else {
                for (let i = 0; i < innerObj2[key].length; i++) {
                  if (innerObj1[key][i] !== innerObj2[key][i]) {
                    differences[key] = [innerObj2[key][i]];
                  }
                }
              }
            } else if (innerObj1[key] !== innerObj2[key]) {
              differences[newPath] = innerObj2[key];
            }
          }
        }
      }

      compareObjects(obj1, obj2, '');

      return differences;
    },
    save(){
      this.save_loading = true
      if (this.user.is_entitled) {
        this.role_posts.forEach(el=>{
          if(el.id){
            this.user.guard_posts.push(el.id)
          }
        })
      } else { this.user.guard_posts = [] }
      if (this.edit) {
        let user = this.findDifferences(this.data_from_server, this.user)
        user.id = this.user.id

        this.changeRoles({
          data: user,
          finalizer: (val) => {
            this.$emit("close", user)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }else {
        this.createRoles({
          data: this.user,
          finalizer: (val) => {
            this.$emit("close", this.user)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }
    }
  },
  created() {
    this.loadUserData()
    this.loadSelectors()
  }
}
</script>

<style scoped>

</style>
